export default __webpack_public_path__ + "static/media/container4.01796bb3.jpg";